export const CONSTANTS = {
    EMPTY_ARTWORK: 'Artwork is empty . . .',
    STUDIO: 'studio',
    WAITING_FOR_ARTWORK: 'Waiting for artwork . . .',
    ZEROFRAME: 'ZEROFRAME',
    NO_FRAME: 'Frame does not exist!',
    SUPPORTED_MEDIA_TYPES: ['image', 'video'],
    
}
